<template>
    <div class="heading-container">
        <div v-if="headline.length > 0" class="custom-headline">
            {{ headline }}
        </div>
        <ul class="filters" v-if="showFilters">
            <div class="select-items">
                <li class="filter__item customDropdown" v-if="titles.length > 1">
                    <label for="titleFilter" class="sr-only">{{ dictionary.EmployeesDropdown }}</label>
                    <select id="titleFilter" class="dropdown-toggle" v-model="title" :disabled="isLoading">
                        <option value="All">{{ dictionary.EmployeesDropdown }}</option>
                        <option v-for="titleItem in titles" :key="titleItem.Key" :value="titleItem.Key">{{
                            titleItem.Name }}</option>
                    </select>
                </li>
                <li class="filter__item customDropdown" v-if="businessAreas.length > 1">
                    <label for="businessAreaFilter" class="sr-only">{{ dictionary.EmployeesDropdownBusinessArea
                    }}</label>
                    <select id="businessAreaFilter" class="dropdown-toggle" v-model="businessArea"
                        :disabled="isLoading">
                        <option value="All">{{ dictionary.EmployeesDropdownBusinessArea }}</option>
                        <option v-for="businessAreaItem in businessAreas" :key="businessAreaItem.Key"
                            :value="businessAreaItem.Key">{{
                                businessAreaItem.Name
                            }}
                        </option>
                    </select>
                </li>
            </div>
            <li class="search-form">
                <label for="employeesSearch" class="sr-only">{{ dictionary.EmployeesSearchInputPlaceholder }}</label>
                <input type="search" id="employeesSearch" v-model="query"
                    :placeholder="dictionary.EmployeesSearchInputPlaceholder" class="search-form__input" />
                <button class="search-form__button" type="submit" aria-label="Søg"></button>
            </li>
        </ul>
    </div>
    <ul class="person-wrapper">
        <li class="person-card" v-for="employee in employees" :key="employee.EmployeeUrl">
            <a :href="employee.EmployeeUrl">
                <div class="person-img">
                    <ResponsiveImage v-if="employee.HasImageForVue" :imageModel="employee.ImageForVue" :key="employee.EmployeeUrl + '-' + employee.ImageForVue.Src"/>
                </div>
                <div class="card-content">
                    <h4>{{ employee.Name }}</h4>
                    <p v-if="employee.HasTitle" class="designation">{{ employee.Title }}</p>
                    <p v-if="employee.HasEmail"><a :href="'mailto:' + employee.Email">{{ employee.Email }}</a></p>
                    <p v-if="employee.HasPhone"><a :href="'tel:' + employee.Phone.replace(/[\s()]/g, '')">{{ employee.Phone }}</a></p>
                    <a v-if="employee.HasLinkdInUrl" :href="employee.LinkdInLink.Url"
                        :target="employee.LinkdInLink.Target" class="icon"><img src="/assets/images/linkedin.png" /></a>
                </div>
            </a>
        </li>
    </ul>

    <div class="employees__footer">
        <div class="employees__no-employees" v-show="!employees.length && !isLoading">
            {{ dictionary.EmployeesNoResults }}
        </div>
    </div>
</template>
<script>
import { nextTick } from 'vue'
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";

const serviceUrl = "/umbraco/api/employeesApi/getEmployees",
    defaultBusinessArea = "All",
    defaultTitle = "All";

var queryTimer;

export default {
    name: "employees",
    components: {
        ResponsiveImage
    },
    data() {
        return {
            dictionary: [],
            titles: [],
            businessAreas: [],
            employees: [],
            isLoading: false,
            hasLoadedInitials: false,
            employeesNodeId: 0,
            isResetting: false,
            showFilters: false,
            headline: ""
        };
    },
    mixins: [
        bindRoute({
            query: null,
            businessArea: defaultBusinessArea,
            title: defaultTitle,
        }),
    ],
    watch: {
        query: {
            handler(newVal, oldVal) {
                clearTimeout(queryTimer);
                queryTimer = setTimeout(() => {
                    this.filterChanged();
                }, 750);
            }
        },
        businessArea: {
            handler() {
                this.filterChanged();
            }
        },
        title: {
            handler() {
                this.filterChanged();
            }
        }
    },
    mounted() {
        this.employeesNodeId = this.$parent.employeesNodeId;
        this.showFilters = this.$parent.showFilters;
        this.headline = this.$parent.headline;

        this.$router.isReady().then(() => {
            this.getInitialEmployees();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        getEmployees() {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);

            const ALL_ITEMS = 9999;

            var object = {
                employeesNodeId: vm.employeesNodeId,
                languageCode: languageCode,
                amountToSkip: 0,
                pageSize: ALL_ITEMS,
            };

            if (vm.query) {
                object.query = vm.query;
            }

            if (vm.businessArea != defaultBusinessArea) {
                object.businessArea = vm.businessArea;
            }

            if (vm.title != defaultTitle) {
                object.title = vm.title;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {
                    vm.employees = data.Items;

                    vm.dictionary = data.Dictionary;
                    vm.businessAreas = data.Facets.BusinessAreas;
                    vm.titles = data.Facets.Titles;

                    nextTick(() => {
                        vm.hasLoadedInitials = true;
                        vm.toggleSpinner(false);
                        vm.isResetting = false;
                    });
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },

        getInitialEmployees() {
            this.getEmployees();
        },

        filterChanged() {
            if (this.hasLoadedInitials && !this.isResetting) {
                this.isResetting = true;
                this.getEmployees();
            }
        },

        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.employees = [];

            vm.businessArea = defaultBusinessArea;
            vm.title = defaultTitle;

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getEmployees();
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasFilterApplied() {
            return this.query || this.title != defaultTitle ||
                this.businessArea != defaultBusinessArea;
        }
    },
};
</script>